import React from 'react';

function Banner() {
  return (
    <section className="banner">
      <div className="banner-bg"></div>
      <div className="container">
        <div className="banner-content">
          <div className="banner-text">
            <span className="banner-label">限定优惠</span>
            <h2 className="banner-title">春季限定系列</h2>
            <p className="banner-desc">融合樱花与春季水果的浪漫滋味，仅限春季供应</p>
            <div className="banner-price">
              <span className="price-label">早鸟价</span>
              <span className="price-value">¥298</span>
              <span className="price-original">¥368</span>
            </div>
            <a href="#" className="btn btn-primary">立即预订</a>
          </div>
          <div className="banner-image">
            <div className="banner-cake">
              <img 
                src="https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=600&q=80" 
                alt="春季限定蛋糕"
                onError={(e) => {
                  e.target.src = 'data:image/svg+xml,<svg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 320 400%22><rect fill=%22%23f8e6d8%22 width=%22320%22 height=%22400%22/><text x=%22160%22 y=%22200%22 text-anchor=%22middle%22 font-size=%2280%22>🎂</text></svg>';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
